/* WhatsApp Floating Button — Website & /login only */

class WhatsAppFAB {
  constructor(opts = {}) {
    this.direction = (window.frappe?.boot?.lang === "ar") ? "rtl" : "ltr";
    this.posSide   = this.direction === "rtl" ? "left" : "right";
    this.phone     = "";
    this.message   = "";
    this.enabled   = true;
    this.opts      = Object.assign({ includePageURL: false }, opts);

    if (document.getElementById("wa-fab")) return; // منع التكرار
    this.injectStyles();
    this.fetchConfig().then(ok => {
      if (!ok) return;
      this.buildButton();
      if (this.isTouchLike()) this.showLabel(true);
    });
  }

  /* ===== Helpers ===== */
  isTouchLike() {
    return (("ontouchstart" in window) || window.matchMedia("(hover: none), (pointer: coarse)").matches);
  }
  normalizePhone(p) { return (p || "").replace(/\D/g, ""); }
  esc(s) { return (s || "").toString(); }
  waLink() {
    const base = "https://wa.me/";
    let text = this.message || "مرحباً! أحتاج مساعدة من الدعم.";
    if (this.opts?.includePageURL) { try { text += "\n" + location.href; } catch(e){} }
    return `${base}${this.phone}?text=${encodeURIComponent(text)}`;
  }

  injectStyles() {
    if (document.getElementById("wa-fab-styles")) return;
    const css = `
:root { --wa-green:#25d366; --wa-green-dark:#128c7e; --wa-shadow:0 10px 18px rgba(0,0,0,0.18); }
#wa-fab { position:fixed; bottom:calc(18px + env(safe-area-inset-bottom,0px)); z-index:1050; direction:rtl; }
#wa-fab .wa-pill { display:inline-flex; align-items:center; gap:10px; text-decoration:none; color:#fff; background:var(--wa-green);
  border-radius:999px; padding:10px 12px; box-shadow:var(--wa-shadow); position:relative; overflow:visible; transition:background 160ms ease; }
#wa-fab .wa-pill:hover { background:var(--wa-green-dark); }
#wa-fab .wa-bg-anim { position:absolute; inset:-6px; border-radius:999px;
  background:conic-gradient(from 0deg, rgba(37,211,102,0.15), rgba(18,140,126,0.25), rgba(37,211,102,0.15));
  z-index:-1; filter:blur(0.5px); transform-origin:50% 50%; animation:wa-spin 6s linear infinite paused; }
@keyframes wa-spin { to { transform:rotate(360deg); } }
#wa-fab .wa-icon { display:inline-flex; width:42px; height:42px; min-width:42px; min-height:42px; align-items:center; justify-content:center;
  border-radius:999px; background:#fff; color:var(--wa-green-dark); box-shadow:inset 0 0 0 2px rgba(255,255,255,0.8); }
#wa-fab .wa-label { white-space:nowrap; max-width:0; opacity:0; transition:max-width 240ms ease, opacity 200ms ease;
  font-weight:600; color:#fff; overflow:hidden; display:inline-block; }
@media (hover:hover) and (pointer:fine) {
  #wa-fab .wa-pill:hover .wa-bg-anim { animation-play-state:running; }
  #wa-fab .wa-pill:hover .wa-label    { max-width:220px; opacity:1; }
}
@media (hover:none), (pointer:coarse) { #wa-fab .wa-label { max-width:220px; opacity:1; } }
@media print { #wa-fab { display:none !important; } }
`;
    const style = document.createElement("style");
    style.id = "wa-fab-styles";
    style.textContent = css;
    document.head.appendChild(style);
  }

  async fetchConfig() {
    // Override للتجربة السريعة من الكونسول
    const ov = (window.WAFAB_OVERRIDE || {});
    if (ov.enabled !== undefined) this.enabled = !!ov.enabled;
    if (ov.phone)   this.phone   = this.normalizePhone(ov.phone);
    if (ov.message) this.message = this.esc(ov.message);

    // قراءة الإعداد من السيرفر
    if (window.frappe?.call) {
      try {
        const r = await frappe.call({ method: "hajzzy.api.server_api.get_whatsapp_support_config", args: {} });
        const cfg = r?.message || {};
        if (typeof cfg.enabled !== "undefined") this.enabled = !!cfg.enabled;
        if (cfg.phone)   this.phone   = this.normalizePhone(cfg.phone);
        if (cfg.message) this.message = this.esc(cfg.message);
      } catch (e) { /* تجاهُل */ }
    }
    return (this.enabled && !!this.phone);
  }

  buildButton() {
    const fab = document.createElement("div");
    fab.id = "wa-fab";
    fab.style[this.posSide] = "18px";

    const svg = `
<svg viewBox="0 0 32 32" width="22" height="22" aria-hidden="true">
  <path d="M19.11 17.27c-.34-.17-2.02-.99-2.34-1.11-.32-.12-.55-.17-.78.17-.23.34-.89 1.11-1.09 1.34-.2.23-.4.26-.74.09-.34-.17-1.44-.53-2.75-1.7-1.02-.91-1.71-2.04-1.91-2.38-.2-.34-.02-.52.15-.69.15-.15.34-.4.51-.6.17-.2.23-.34.34-.57.12-.23.06-.43-.03-.6-.09-.17-.78-1.87-1.07-2.56-.28-.68-.57-.59-.78-.6-.2-.01-.43-.01-.66-.01-.23 0-.6.09-.92.43-.32.34-1.21 1.18-1.21 2.88 0 1.7 1.24 3.34 1.41 3.57.17.23 2.44 3.73 5.91 5.22.83.36 1.48.58 1.98.74.83.26 1.58.22 2.17.13.66-.1 2.02-.82 2.31-1.62.29-.8.29-1.49.2-1.62-.09-.13-.31-.2-.65-.37z" fill="currentColor"></path>
  <path d="M16 3C9.93 3 5 7.93 5 14c0 2.44.82 4.69 2.2 6.49L6 27l6.69-1.76C14.59 25.74 15.28 26 16 26c6.07 0 11-4.93 11-11S22.07 3 16 3zm0 20.2c-.62 0-1.22-.09-1.78-.27l-.39-.12-3.97 1.04 1.06-3.87-.13-.4C9.29 18.02 9 16.99 9 16c0-3.86 3.14-7 7-7s7 3.14 7 7-3.14 7-7 7z" fill="currentColor"></path>
</svg>`.trim();

    fab.innerHTML = `
  <a href="#" class="wa-pill" id="wa-fab-link" target="_blank" rel="noopener" aria-label="التواصل عبر واتساب" title="التواصل عبر واتساب">
    <span class="wa-bg-anim" aria-hidden="true"></span>
    <span class="wa-icon" aria-hidden="true">${svg}</span>
    <span class="wa-label" dir="ltr"></span>
  </a>`;
    document.body.appendChild(fab);

    fab.querySelector(".wa-label").textContent = this.phone;

    const link = fab.querySelector("#wa-fab-link");
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const url = this.waLink();
      if (this.isTouchLike()) window.location.href = url;
      else window.open(url, "_blank", "noopener");
    });
  }

  showLabel(force = true) {
    const label = document.querySelector("#wa-fab .wa-label");
    if (!label) return;
    label.style.maxWidth = force ? "220px" : "0";
    label.style.opacity  = force ? "1" : "0";
  }
}

/* ===== نطاق الظهور: صفحات الويب + /login فقط (خارج الـ Desk) ===== */

/* ===== Bootstrap: Website-first (بديل عن after_ajax) ===== */
function isDeskRoute() {
  const p = (location.pathname || "").toLowerCase();
  return p.startsWith("/app") || p.startsWith("/desk");
}
function isLoginRoute() {
  return (location.pathname || "").toLowerCase() === "/login";
}
// Website-only scope (كل صفحات الويب + /login، ويختفي في الـ Desk)
function pageScopeOk() {
  if (isDeskRoute()) return false;
  if (isLoginRoute()) return true;
  return true; // باقي صفحات الويب
}

function bootstrapWAFAB() {
  if (window._waFabInitialized) return;
  if (!pageScopeOk()) return;
  window._waFabInitialized = true;
  new WhatsAppFAB({ includePageURL: false });
}

// 1) لصفحات الويب: frappe.ready (لو متاح)
if (typeof frappe !== "undefined" && typeof frappe.ready === "function") {
  try { frappe.ready(bootstrapWAFAB); } catch(e) {}
}

// 2) احتياط: DOMContentLoaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", bootstrapWAFAB, { once: true });
} else {
  bootstrapWAFAB();
}

// 3) للرجوع من bfcache / التنقل التاريخي في بعض المتصفحات
window.addEventListener("pageshow", bootstrapWAFAB, { once: true });
